import * as React from 'react';
import * as _ from 'lodash';
import { IApplicationState, RecipientActionCreators, AppActionCreators, IPotentialDonorListResponse, DonorPreselectActionCreators } from '@nkr/store/index';
import { IBaseResponse, IFwtSummary, IListItem, IMortalityCalculations, IPreselectDonorInfo, IRecipient } from '@nkr/models/index';
import { DonorPreselectBulkUpdateType, DonorPreselectReviewStatus, MatchOfferDeclineReason, MortalityMatchType } from '@nkr/enums/index';
import { Dispatch, connect } from 'react-redux';
import { PreSelectSection } from '@nkr/enums/preselect-section'
import { PreSelectSubSection } from '@nkr/enums/preselect-sub-section'
import { Actions, IRowData, IPreselectsCount } from './models/index';
import { orderByPreSelectDefault } from './models/default-sort';
import { toast } from 'react-toastify';
import * as qs from 'query-string';
import { TabWrapper } from './styles';
import RecipientNav from '../recipient-nav';
import SubSectionFilters from './sub-section-filters';
import RecipientInfo from './recipient-info';
import ConfirmNotFullyConfident from './confirm-not-fully-confident';
import HardBlock from '@nkr/views/match/modals/hard-block';
import PotentialDonorList from './list2';
import SectionFilters from './section-filters'
import ConfirmBulkDecline from './confirm-bulk-decline';
import MortalityBreakdown from '@nkr/components/mortality-breakdown-modal';
import FwtDetailsModal from '@nkr/views/target-new/modals/fwt-details-modal';

interface IProps {
    recipientId: number,
    centerId: number,
    onUpdateRecipientAlias: (alias: string) => void
}

interface IStateProps {
    groupIsSuper: boolean
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getPotentialDonors: (recipientId: number, centerId: number) => Promise<IPotentialDonorListResponse>,
    acceptDonor: (recipientId: number, donorId: number, isFullyConfident: boolean, hasMortalityRisk: boolean) => Promise<IBaseResponse>,
    declineDonor: (recipientId: number, recipientCenterId: number, donorId: number, declineReasons: { reasonId: number, otherText: string }[], isGlobalDecline: boolean, hasMortalityRisk: boolean) => Promise<IBaseResponse>,
    updateReviewStatus: (recipientId: number, donorId: number, reviewStatus: DonorPreselectReviewStatus) => Promise<IBaseResponse>,
    bulkUpdatePreselects: (bulkUpdateType: DonorPreselectBulkUpdateType, recipientId: number, list: number[], isAccepted: boolean, isFullyConfident: boolean, hardBlockReason: number, reviewStatus: DonorPreselectReviewStatus) => Promise<IBaseResponse>,
    bulkDeclineMultiPreselects: (recipientId: number, list: number[], hardBlockReasons: { reasonId: number, otherText: string }[]) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IProps;

const otherTypes = [MatchOfferDeclineReason.DonorOther, MatchOfferDeclineReason.SurgeryDateOther, MatchOfferDeclineReason.PatientDeactivateOther] as number[];

interface IState {
    recipient: IRecipient,
    waitEstimate: string,
    recipientFwt: string,
    declineWait: string,
    declinePercent: number,
    potentialDonors: IRowData[],
    pairedDonors: IRowData[],
    pendingMatchHistoryDonorId: number,
    hardBlockReasonList: IListItem[],
    donorPreselectReviewStatusList: IListItem[],
    section: PreSelectSection,
    subSection: PreSelectSubSection,
    notFullyConfident: {
        show: boolean,
        donorId: number
    },
    hardBlock: {
        show: boolean,
        donor: IPreselectDonorInfo,
        isBulkUpdate: boolean,
        reasons: number[],
        otherText: string
    },
    bulkDecline: {
        show: boolean,
        reasons: string[],
        otherText: string
    },
    bulkUpdate: {
        action: string,
        reason: number
    },
    sortByAccessor: string,
    sortByDesc: boolean,
    selectAll: boolean,
    showBusy: boolean,
    hardblockDonorIds: number[],
    hardblockReasons: number[],
    mortalityBreakdown: {
        show: boolean,
        recipientAlias: string,
        data: IMortalityCalculations
    },
    fwtSummary: IFwtSummary,
    fwt: {
        show: boolean
    }
}

class PotentialDonors extends React.Component<TProps, IState> {
    readonly state: IState = {
        recipient: null,
        waitEstimate: '',
        recipientFwt: '',
        declineWait: '',
        declinePercent: 0,
        potentialDonors: [],
        pairedDonors: [],
        pendingMatchHistoryDonorId: 0,
        hardBlockReasonList: [],
        donorPreselectReviewStatusList: [],
        section: PreSelectSection.PotentialDonors,
        subSection: PreSelectSubSection.All,
        notFullyConfident: {
            show: false,
            donorId: 0
        },
        hardBlock: {
            show: false,
            donor: null,
            isBulkUpdate: false,
            reasons: [],
            otherText: null
        },
        bulkDecline: {
            show: false,
            reasons: [],
            otherText: null
        },
        bulkUpdate: {
            action: '',
            reason: 0
        },
        sortByAccessor: '',
        sortByDesc: false,
        selectAll: false,
        showBusy: false,
        hardblockDonorIds: [],
        hardblockReasons: [],
        mortalityBreakdown: {
            show: false,
            recipientAlias: '',
            data: null
        },
        fwtSummary: null,
        fwt: {
            show: false,
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = async () => {
        let q = qs.parse(location.search);
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(''), { arrayFormat: 'bracket' });
        var showCalc = parsed.showCalc != null ? parseInt(parsed.showCalc) : -1;
        await this.props.showLoading('Getting potential donors, one moment please...');

        let response = await this.props.getPotentialDonors(this.props.recipientId, this.props.centerId);

        if (response.data.success) {
            let { recipient, fwtSummary, waitEstimate, recipientFwt, declinePercent, declineWait, potentialDonors, pendingMatchHistoryDonorId, hardBlockReasonList, donorPreselectReviewStatusList } = response.data.results;

            this.setState({
                fwtSummary: fwtSummary
            });

            let l: IRowData[] = potentialDonors.map(item => {
                return {
                    ...item,
                    donor: item.donor,
                    isSelected: false,
                    isFirst: false,
                    recipient: recipient
                };
            });

            if (showCalc == 1) {
                this.setState({
                    mortalityBreakdown: {
                        show: true,
                        recipientAlias: recipient.alias,
                        data: recipient.mortalityCalculations
                    }
                })
            }

            if (showCalc == 2) {
                this.setState({
                    fwt: {
                        show: true
                    }
                });
            }

            let pairedDonors = l.filter(x => x.isPairedDonor && x.donor.isDeleted == false);

            l = l.filter(x => x.isPairedDonor == false);

            this.setState({
                recipient,
                waitEstimate,
                recipientFwt,
                declinePercent,
                declineWait,
                pendingMatchHistoryDonorId,
                hardBlockReasonList,
                donorPreselectReviewStatusList,
                potentialDonors: l,
                pairedDonors,
            }, () => {
                this.props.onUpdateRecipientAlias(this.state.recipient.alias);
            });
        }

        this.props.hideLoading();
    }

    applySectionFilter = (data: IRowData[], section: PreSelectSection): IRowData[] => {
        let recipientAge = parseInt(this.state.recipient.age);

        let newData = data.filter(x => {
            let { donor: { isPotentialDonor, isAvoided, isBadPmpc, isHardToMatch, isInMatch, isBioMatch, pairMatchPower, donorTypeId, isBadAboMatch, isBadAgeMatch, isBiologicalMatch, isAboCompatible, isPediatricAgeCutoff } } = x;

            if (section == PreSelectSection.PotentialDonors) {
                return isPotentialDonor == true || (recipientAge <= 21 ? isBioMatch == true : false);
            }

            if (section == PreSelectSection.AvoidConflict) {
                return isAboCompatible && !isBiologicalMatch && !isBadPmpc;
            }

            if (section == PreSelectSection.InMatch) {
                return isInMatch == true && !isBadAboMatch && !isBadAgeMatch && isBioMatch && !isBadPmpc && ((recipientAge <= 21 && isPediatricAgeCutoff == false) || recipientAge > 21);
            }

            if (section == PreSelectSection.BioMatch) {
                return isBioMatch == true;
            }

            if (section == PreSelectSection.All) {
                return true;
            }
        });

        let filteredData = this.applySubSectionFilter(newData);

        return orderByPreSelectDefault(filteredData);
    }

    applySubSectionFilter = (data: IRowData[]) => {
        let { subSection } = this.state;

        return data.filter(x => {
            let { donor: { isAccepted } } = x;

            if (subSection == PreSelectSubSection.Accepted) {
                return isAccepted == true;
            }

            if (subSection == PreSelectSubSection.Pending) {
                return isAccepted == null;
            }

            if (subSection == PreSelectSubSection.Declined) {
                return isAccepted == false;
            }

            if (subSection == PreSelectSubSection.All) {
                return true;
            }
        });
    }

    getSubSectionCounts = (data: IRowData[]): IPreselectsCount => {
        let counts = {
            all: 0,
            pending: 0,
            accepted: 0,
            declined: 0
        }

        let recipientAge = parseInt(this.state.recipient.age);

        let newData = data.filter(x => {
            let { donor: { isPotentialDonor, isAvoided, isBadPmpc, isHardToMatch, isInMatch, isBioMatch, pairMatchPower, donorTypeId, isBadAboMatch, isBadAgeMatch, isBiologicalMatch, isAboCompatible, isPediatricAgeCutoff } } = x;
            return (isPotentialDonor == true || (recipientAge <= 21 && isBioMatch == true)) ? true : false;
        });

        newData.forEach(x => {
            let { donor: { isAccepted } } = x;

            if (isAccepted == true) {
                counts.accepted++;
            }

            if (isAccepted == null) {
                counts.pending++;
            }

            if (isAccepted == false) {
                counts.declined++;
            }

            counts.all++
        });

        return counts;
    };

    handleChangeSection = (section: PreSelectSection) => {
        this.setState({
            section,
            subSection: PreSelectSubSection.All,
            selectAll: false
        });
    }

    acceptDonor = (donorId: number, isFullyConfident: boolean) => {
        let { hasMortalityRisk } = this.state.recipient;

        this.props.showLoading('Accepting donor, one moment please...').then(() => {
            this.props.acceptDonor(this.props.recipientId, donorId, isFullyConfident, hasMortalityRisk).then(response => {
                if (response.data.success) {
                    this.props.hideLoading()
                    toast.success('Donor preselect updated successfully');
                    this.getData();
                }
            });
        }).catch((err: any) => {
            this.props.hideLoading()
        });
    }

    declineDonor = (donorId: number, hardBlockReasons: number[], hardBlockComments: string, isGlobalDecline: boolean) => {
        let { id, centerId, hasMortalityRisk } = this.state.recipient;

        let declineReasons = hardBlockReasons.map(x => {
            return { reasonId: x, otherText: hardBlockComments && otherTypes.includes(x) ? hardBlockComments : null }
        })

        this.props.showLoading('Declining donor, one moment please...').then(() => {
            this.props.declineDonor(id, centerId, donorId, declineReasons, isGlobalDecline, hasMortalityRisk).then(response => {
                if (response.data.success) {
                    this.props.hideLoading()
                    toast.success('Donor preselect updated successfully');
                    this.handleCancelHardBlock();
                    this.getData();
                }
            });
        }).catch((err: any) => {
            this.props.hideLoading()
        });
    }

    handleSubTabChange = (subSection: PreSelectSubSection) => {
        this.setState({
            subSection,
            selectAll: false
        });
    }

    handleSortChange = (sortByAccessor: string, sortByDesc: boolean) => {
        this.setState({
            sortByAccessor,
            sortByDesc
        });
    }

    handleAction = (recipientId: number, donorId: number, action: Actions) => {
        let potentialDonors = _.cloneDeep(this.state.potentialDonors.map(x => {
            if (x.donor.id == donorId) {
                switch (action) {
                    case Actions.AcceptableFullyConfident:
                        x.donor.isAccepted = true;
                        x.donor.isFullyConfident = true;
                        break;

                    case Actions.AcceptableNotFullyConfident:
                        if (this.state.recipient.cpra4 >= 99) {
                            this.setState({
                                notFullyConfident: {
                                    show: true,
                                    donorId
                                }
                            });
                        } else {
                            x.donor.isAccepted = true;
                            x.donor.isFullyConfident = false;
                        }

                        break;

                    case Actions.NotAcceptable:
                        this.setState({
                            hardBlock: {
                                show: true,
                                donor: x.donor,
                                isBulkUpdate: false,
                                reasons: [],
                                otherText: null
                            }
                        });

                        break;

                    case Actions.Evaluate:
                        window.open('/center/' + this.props.centerId + '/recipient/' + this.props.recipientId + '/evaluate-donor/' + donorId, '_blank');
                        break;
                }
            }

            return x;
        }));

        if (action == Actions.AcceptableFullyConfident) {
            this.acceptDonor(donorId, true);
        }

        if (action == Actions.AcceptableNotFullyConfident && this.state.recipient.cpra4 < 99) {
            this.acceptDonor(donorId, false);
        }

        this.setState({
            potentialDonors
        });
    }

    handleOnMultiHardblock = (isBulkUpdate: boolean = false) => {
        this.setState({
            hardBlock: {
                show: true,
                donor: null,
                isBulkUpdate,
                otherText: null,
                reasons: []
            }
        })
    }

    handleDonorSelectAll = () => {
        let potentialDonors = _.cloneDeep(this.applySectionFilter(this.state.potentialDonors, this.state.section));

        potentialDonors = potentialDonors.map(x => {
            x.isSelected = !this.state.selectAll
            return x;
        });

        this.setState({
            potentialDonors,
            selectAll: !this.state.selectAll
        });
    }

    handleDonorSelected = (recipientId: number, donorId: number, checked: boolean) => {
        let potentialDonors = _.cloneDeep(this.state.potentialDonors);

        potentialDonors = potentialDonors.map(x => {
            if (x.donor.id == donorId) {
                x.isSelected = checked;
            }

            return x;
        });

        this.setState({
            potentialDonors
        });
    }

    handleBulkUpdate = (bulkUpdateAction: string, isAccepted: boolean, isFullyConfident: boolean, hardBlockReason: number, reviewStatus: DonorPreselectReviewStatus) => {
        let list = this.state.potentialDonors.filter(x => x.isSelected).map(x => x.donor.id);
        var bulkUpdateType = bulkUpdateAction == 'decline' ? DonorPreselectBulkUpdateType.Decision : DonorPreselectBulkUpdateType.Review;

        this.props.showLoading('Updating selected donors, one moment please...').then(() => {
            this.props.bulkUpdatePreselects(bulkUpdateType, this.props.recipientId, list, isAccepted, isFullyConfident, hardBlockReason, reviewStatus).then(response => {
                if (response.data.success) {
                    this.props.hideLoading();
                    toast.success('Donor preselects bulk updated successfully');
                    this.getData();
                }
            });
        }).catch((err: any) => {
            this.props.hideLoading();
        });
    }

    handleHardBlock = (ids: number[], otherText: string) => {
        let { hardBlock } = this.state;

        if (hardBlock.isBulkUpdate) {
            this.setState({
                hardBlock: {
                    show: false,
                    donor: null,
                    reasons: ids,
                    otherText,
                    isBulkUpdate: true
                }
            }, () => {
                this.handleShowConfirmBulkDecline()
            })
        } else {
            this.declineDonor(hardBlock.donor.id, ids, otherText, false);
        }
    }

    handleCancelHardBlock = () => {
        this.setState({
            hardBlock: {
                show: false,
                donor: null,
                isBulkUpdate: false,
                reasons: [],
                otherText: null
            },
            bulkDecline: {
                show: false,
                reasons: [],
                otherText: null
            },
            hardblockReasons: []
        });
    }

    handleHardBlockDonors = (ids: number[], otherText: string) => {
        let list = this.state.potentialDonors.filter(x => x.isSelected).map(x => x.donor.id);

        let hardblockReasons = ids.map(x => {
            return {
                reasonId: x,
                otherText: otherTypes.includes(x) ? otherText : null
            }
        })

        this.props.showLoading('Updating selected donors, one moment please...').then(() => {
            this.props.bulkDeclineMultiPreselects(this.props.recipientId, list, hardblockReasons).then(response => {
                if (response.data.success) {
                    this.props.hideLoading();
                    toast.success('Donor preselect(s) Updated');
                    this.getData();
                    this.handleCancelHardBlock()
                }
            });
        }).catch((err: any) => {
            this.props.hideLoading();
        });
    }

    handleConfirmNotFullyConfidentYes = () => {
        let { donorId } = this.state.notFullyConfident;

        this.setState({
            notFullyConfident: {
                show: false,
                donorId: 0
            }
        }, () => {
            let potentialDonors = _.cloneDeep(this.state.potentialDonors.map(x => {
                if (x.donor.id == donorId) {
                    x.donor.isAccepted = true;
                    x.donor.isFullyConfident = false;
                    x.donor.hasPendingXm = true;
                }

                return x;
            }));

            this.setState({
                potentialDonors
            }, () => {
                this.acceptDonor(donorId, false);
            });
        });
    }

    handleConfirmNotFullyConfidentNo = () => {
        this.setState({
            notFullyConfident: {
                show: false,
                donorId: 0
            }
        });
    }

    handleReviewStatusChange = (recipientId: number, donorId: number, reviewStatus: DonorPreselectReviewStatus) => {
        let potentialDonors = _.cloneDeep(this.state.potentialDonors);

        this.setState({
            showBusy: true
        }, () => {
            this.props.updateReviewStatus(recipientId, donorId, reviewStatus)
                .then(response => {
                    if (response.data.success) {
                        potentialDonors = potentialDonors.map(item => {
                            if (item.donor.id == donorId) {
                                item.reviewStatus = reviewStatus;
                            }

                            return item;
                        });

                        this.setState({
                            potentialDonors,
                            showBusy: false
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    handleShowConfirmBulkDecline = () => {
        let { hardBlock } = this.state;

        let currentHardBlockReasons = hardBlock.reasons;

        let filteredReasons = this.state.hardBlockReasonList.filter(x => currentHardBlockReasons.includes(x.id))

        let reasons = filteredReasons.map(x => x.description);

        this.setState({
            bulkDecline: {
                show: true,
                reasons,
                otherText: hardBlock.otherText
            }
        })
    }

    handleHideConfirmBulkDecline = () => {
        this.setState({
            hardBlock: {
                show: false,
                donor: null,
                reasons: [],
                isBulkUpdate: false,
                otherText: null
            },
            bulkDecline: {
                show: false,
                reasons: [],
                otherText: null
            },
            hardblockReasons: []
        });
    }

    handleConfirmBulkDecline = () => {
        let { hardBlock, bulkDecline } = this.state;
        this.handleHardBlockDonors(hardBlock.reasons, bulkDecline.otherText);
    }

    handleShowMortalityBreakdown = (recipient: IRecipient) => {
        this.setState({
            mortalityBreakdown: {
                show: true,
                recipientAlias: recipient.alias,
                data: recipient.mortalityCalculations
            }
        });
    }

    handleMortalityBreakdownClose = () => {
        this.setState({
            mortalityBreakdown: {
                show: false,
                recipientAlias: '',
                data: null
            }
        });
    }

    handleShowFwt = (recipient: IRecipient) => {
        this.setState({
            fwt: { show: true }
        });
    }


    handleFwtClose = () => {
        this.setState({
            fwt: { show: false }
        });
    }

    render = () => {
        if (this.state.recipient == null)
            return null;

        const data = this.applySectionFilter(this.state.potentialDonors, this.state.section);
        const counts = this.getSubSectionCounts(this.state.potentialDonors);

        const hardBlockReasonChoices = this.state.hardBlockReasonList.filter(x => this.state.hardblockReasons.includes(x.id)).map(x => x.description);
        const selectedDonors = this.state.potentialDonors.filter(x => x.isSelected);
        const potentialDonorsForBulkUpdate = selectedDonors != null ? selectedDonors : [];

        return (
            <div style={{ padding: 10 }}>
                <RecipientNav
                    activeKey={'POTENTIAL-DONORS'}
                    isAdmin={false}
                    isNkrLogin={this.props.groupIsSuper}
                    centerId={this.props.centerId}
                    recipientId={this.props.recipientId}
                    recipientAlias={this.state.recipient.alias}
                />

                <SectionFilters
                    activeTab={this.state.section}
                    data={this.state.potentialDonors}
                    recipient={this.state.recipient}
                    onTabChange={this.handleChangeSection}
                />

                <TabWrapper>
                    <div style={{ width: "100%", minHeight: "65vh", padding: '10px 10px 10px 10px', marginBottom: 10, backgroundColor: "#FFF" }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 5 }}>
                            {this.state.section == PreSelectSection.PotentialDonors &&
                                <SubSectionFilters
                                    centerId={this.props.centerId}
                                    activeTab={this.state.subSection}
                                    data={counts}
                                    showBusy={this.state.showBusy}
                                    onTabChange={this.handleSubTabChange}
                                />
                            }
                        </div>

                        <RecipientInfo
                            recipient={this.state.recipient}
                            list={this.state.potentialDonors}
                            waitEstimate={this.state.waitEstimate}
                            recipientFwt={this.state.recipientFwt}
                            declineWait={this.state.declineWait}
                            declinePercent={this.state.declinePercent}
                            onShowMortalityBreakdown={this.handleShowMortalityBreakdown}
                            onShowFWTBreakdown={this.handleShowFwt}
                        />

                        <PotentialDonorList
                            list={data}
                            pairedDonors={this.state.pairedDonors}
                            centerId={this.props.centerId}
                            recipient={this.state.recipient}
                            pendingMatchHistoryDonorId={this.state.pendingMatchHistoryDonorId}
                            hardBlockReasons={this.state.hardBlockReasonList}
                            hardBlockReasonChoices={hardBlockReasonChoices}
                            donorPreselectReviewStatusList={this.state.donorPreselectReviewStatusList}
                            groupIsSuper={this.props.groupIsSuper}
                            section={this.state.section}
                            subSection={this.state.subSection}
                            onSortChange={this.handleSortChange}
                            onAction={this.handleAction}
                            onMultiHardblock={this.handleOnMultiHardblock}
                            onSelectAll={this.handleDonorSelectAll}
                            onSelected={this.handleDonorSelected}
                            onBulkUpdate={this.handleBulkUpdate}
                            onReviewStatusChange={this.handleReviewStatusChange}
                        />
                    </div>
                </TabWrapper>

                <HardBlock
                    show={this.state.hardBlock.show}
                    alias={this.state.hardBlock.donor != null ? this.state.hardBlock.donor.alias : ''}
                    centerAlias={this.state.hardBlock.donor != null ? this.state.hardBlock.donor.centerAlias : ''}
                    isGlobalDecline={false}
                    warnOnHighDeclineRatio={this.state.recipient.warnOnHighDeclineRatio}
                    hardBlockReasons={this.state.hardBlockReasonList}
                    hasMortalityRisk={this.state.recipient.hasMortalityRisk}
                    mortalityRiskPercent={this.state.recipient.mortalityRiskPercent}
                    onDeclineDonor={this.handleHardBlock}
                    onCancel={this.handleCancelHardBlock}
                />

                <ConfirmBulkDecline
                    show={this.state.bulkDecline.show}
                    reasons={this.state.bulkDecline.reasons}
                    list={potentialDonorsForBulkUpdate}
                    onYes={this.handleConfirmBulkDecline}
                    onNo={this.handleHideConfirmBulkDecline}
                />

                <ConfirmNotFullyConfident
                    show={this.state.notFullyConfident.show}
                    onYes={this.handleConfirmNotFullyConfidentYes}
                    onNo={this.handleConfirmNotFullyConfidentNo}
                />

                <MortalityBreakdown
                    show={this.state.mortalityBreakdown.show}
                    recipientAlias={this.state.mortalityBreakdown.recipientAlias}
                    data={this.state.mortalityBreakdown.data}
                    onClose={this.handleMortalityBreakdownClose}
                />

                <FwtDetailsModal
                    show={this.state.fwt.show}
                    summaryData={this.state.fwtSummary}
                    onClose={this.handleFwtClose}
                />
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        groupIsSuper: appState.app.user.group.isSuper
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getPotentialDonors: (recipientId, centerId) => {
            return dispatch(RecipientActionCreators.getPotentialDonors(recipientId, centerId));
        },
        acceptDonor: (recipientId, donorId, isFullyConfident, hasMortalityRisk) => {
            return dispatch(DonorPreselectActionCreators.acceptDonor(recipientId, donorId, isFullyConfident, hasMortalityRisk, MortalityMatchType.PotentialDonors));
        },
        declineDonor: (recipientId, recipientCenterId, donorId, declineReasons, isGlobalDecline, hasMortalityRisk) => {
            return dispatch(DonorPreselectActionCreators.declineDonor(recipientId, recipientCenterId, donorId, 'Pre-Select', declineReasons, isGlobalDecline, hasMortalityRisk, MortalityMatchType.PotentialDonors));
        },
        updateReviewStatus: (recipientId, donorId, reviewStatus) => {
            return dispatch(DonorPreselectActionCreators.updateReviewStatus(recipientId, donorId, reviewStatus));
        },
        bulkUpdatePreselects: (bulkUpdateType, recipientId, list, isAccepted, isFullyConfident, hardBlockReason, reviewStatus) => {
            return dispatch(DonorPreselectActionCreators.bulkUpdatePreselects(bulkUpdateType, recipientId, list, isAccepted, isFullyConfident, hardBlockReason, reviewStatus));
        },
        bulkDeclineMultiPreselects: (recipientId, list, hardBlockReasons) => {
            return dispatch(DonorPreselectActionCreators.bulkDeclineMultiPreselects(recipientId, list, hardBlockReasons))
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps, mapDispatchToProps)(PotentialDonors)